export const tiers = {
  ELITE: 'Elite',
  ETOILE: 'Etoile',
  AVANTAGE: 'Avantage',
  CARTE_BLANCHE: 'Carte Blanche',
  CLASSIQUE: 'Classique'
};

export const membershipStatusTiers = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive'
};
